"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsHeader = void 0;
var react_1 = __importDefault(require("react"));
var Button_1 = require("office-ui-fabric-react/lib/Button");
var Text_1 = require("office-ui-fabric-react/lib/Text");
/**
 * AI Hub Settings page header with the Save / Discard controls and the
 * page-level description copy.
 */
exports.SettingsHeader = function (props) {
    var hasChanges = props.hasChanges, isSaving = props.isSaving, onSave = props.onSave, onDiscard = props.onDiscard;
    return (react_1.default.createElement("div", { className: "ws-tab-header" },
        react_1.default.createElement("div", { className: "ws-header-row" },
            react_1.default.createElement("div", { className: "ws-header-left" },
                react_1.default.createElement("div", { className: "ws-save-controls" },
                    react_1.default.createElement(Text_1.Text, { variant: "small", className: "ws-save-controls-label" }, "Data Sources"),
                    react_1.default.createElement("div", { className: "ws-save-controls-row" },
                        react_1.default.createElement(Button_1.PrimaryButton, { className: "ws-admin-button-filled-primary", iconProps: {
                                iconName: isSaving ? "Sync" : "Save",
                                className: isSaving ? "ws-spin" : "",
                            }, disabled: !hasChanges || isSaving, text: isSaving ? "Saving..." : "Save Changes", onClick: onSave }),
                        react_1.default.createElement(Button_1.IconButton, { className: "ws-admin-button-neutral-icon", disabled: !hasChanges || isSaving, iconProps: { iconName: "Undo" }, title: "Discard Changes", ariaLabel: "Discard Changes", onClick: onDiscard })))),
            react_1.default.createElement("div", { className: "ws-header-right" },
                react_1.default.createElement(Text_1.Text, { variant: "medium", className: "ws-page-description" }, "Configure source systems and the field mapping schema that connects those systems to AI Hub use case data. Save is wired to a stub API for now, so submissions are accepted and acknowledged without being persisted to the database yet.")))));
};
